import React from "react";
import ModalV2 from "../modalV2";
import ButtonV2 from "../buttonV2";

function DeleteModal({
  open,
  close,
  deleteTitle,
  warningMessage,
  lastmessage,
  handleDelete,
  loading,
}: {
  open: boolean;
  close: () => void;
  deleteTitle: string;
  warningMessage: string;
  lastmessage: string;
  handleDelete: () => void;
  loading: boolean;
}) {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth={"w-[400px]"}
      edges={"rounded-xl"}
    >
      <div className="">
        <div className="border-b text-lg font-semibold text-customDark px-5 py-3 flex items-start">
          Delete {deleteTitle}?
        </div>

        <div className="flex flex-col gap-y-2 items-center justify-center p-5">
          <span className="text-lg font-medium text-[#2A2E34]">
            {" "}
            Are you sure you want to delete {warningMessage}?
          </span>
          <span className="text-[16px] font-medium text-[#5D7284]">
            This {lastmessage.endsWith("s") && lastmessage.slice(0, -1)} will be
            permanently removed from your {lastmessage} and cannot be recovered.
          </span>
        </div>

        <div className="flex w-full items-center gap-x-3 p-5">
          <ButtonV2
            title={"Cancel"}
            btnStyle={"w-full border border-borderColor rounded-xl p-3"}
            textStyle={"text-sm font-medium text-customDark"}
            handleClick={close}
          />
          <ButtonV2
            title={"Yes, Delete"}
            btnStyle={
              "w-full bg-[#FF3B2D] flex items-center justify-center rounded-xl p-3"
            }
            loaderColor="#ffffff"
            loading={loading}
            textStyle={"text-sm font-medium text-white"}
            handleClick={handleDelete}
          />
        </div>
      </div>
    </ModalV2>
  );
}

export default DeleteModal;
